import React from 'react';
import { StyledTD } from './styles';

export type TDProps = React.TdHTMLAttributes<HTMLTableCellElement>;

const TD: React.FC<TDProps> = props => <StyledTD {...props} />;

export default TD;
